// extracted by mini-css-extract-plugin
export default {"summary-container":"BranchGroupSummary_summary-container__p0H03","summary-ctas":"BranchGroupSummary_summary-ctas__fIO7c"};